
import { io } from "socket.io-client";

const socket = io(import.meta.env.VITE_SERVER_URL, {
    transports: ['websocket'],
    autoConnect: true
});

socket.on("connect", () => {
    console.log('[websocket] connected', socket.id)
});

socket.on("disconnect", () => {
    console.log('[websocket] disconnected')
});

export default socket